'use client';
import React, { useEffect, useState } from 'react';
import PurchaseSuccessNotificationComponent, {
  PurchaseSuccessNotificationProps,
} from './PurchaseSuccessNotification';
import { Stripe, loadStripe } from '@stripe/stripe-js';
import { usePostHog } from 'posthog-js/react';

const STRIPE_PUBLIC_KEY = process.env
  .NEXT_PUBLIC_STRIPE_KEY as string;

const PurchaseSuccessNotification = () => {
  const posthog = usePostHog();
  const [message, setMessage] = useState<string | undefined>();
  const [succeeded, setSucceeded] = useState(false);
  const [state, setState] =
    useState<PurchaseSuccessNotificationProps>({
      session: {
        duration: 0,
        slot: '',
      },
      mentor: {
        name: '',
        avatar_url: '',
      },
    });

  const [stripe, setStripe] = useState<null | Stripe>(null);

  useEffect(() => {
    console.log('message', message);
  }, [message]);

  useEffect(() => {
    loadStripe(STRIPE_PUBLIC_KEY).then((stripe) => setStripe(stripe));
  }, []);

  useEffect(() => {
    if (!stripe) {
      return;
    }

    const clientSecret = new URLSearchParams(
      window.location.search
    ).get('payment_intent_client_secret');

    if (!clientSecret) {
      return;
    }

    stripe
      .retrievePaymentIntent(clientSecret)
      .then(({ paymentIntent }) => {
        if (!paymentIntent) return;

        switch (paymentIntent.status) {
          case 'succeeded':
            const successMetadata = localStorage.getItem(
              'success_metadata'
            );
            if (!successMetadata)
              throw new Error('Success metadata not found');
            const metadata = JSON.parse(successMetadata);
            setState(metadata);
            try {
              // Critical for analytics, marks the completion of a purchase in the funnel
              const amount = paymentIntent.amount;
              posthog.capture(
                '[ONE PAGE CHECKOUT] purchase succeeded',
                {
                  mentor_id: metadata.mentor.id,
                  session_duration: metadata.session.duration,
                  session_slot: metadata.session.slot,
                  value: amount / 100,
                  currency: 'USD',
                }
              );
            } catch (error) {
              console.error(error);
            }
            setSucceeded(true);
            break;
          case 'processing':
            setMessage('Your payment is processing.');
            break;
          case 'requires_payment_method':
            posthog.capture('[ONE PAGE CHECKOUT] purchase_failed', {
              reason: 'requires_payment_method',
            });
            setMessage(
              'Your payment was not successful, please try again.'
            );
            break;
          default:
            setMessage('Something went wrong.');
            posthog.capture('[ONE PAGE CHECKOUT] purchase_failed', {
              reason: 'unknown_error',
            });
            break;
        }
      });
  }, [posthog, stripe]);

  // THIS WAS A BAD IDAS AS THE SUCCESS METADATA IS SET TOO EARLY
  // useEffect(() => {
  //   const successMetadata = localStorage.getItem("success_metadata");
  //   if(!successMetadata) return;
  //   const metadata = JSON.parse(successMetadata);
  //   console.log("metadata", metadata);
  //   setState(metadata);
  //   setSucceeded(true);
  // }, [window.location]);

  const createAccount = () => {
    const onboardingUrl = localStorage.getItem('onboarding_url');
    if (onboardingUrl) {
      localStorage.clear(); // clear the values so the sucess dosen't show again
      window.location.href = onboardingUrl;
    } else {
      throw new Error('Onboarding URL not found');
    }
  };

  return !!succeeded ? (
    <PurchaseSuccessNotificationComponent
      {...state}
      createAccount={createAccount}
    />
  ) : null;
};

export default PurchaseSuccessNotification;
